import { httpClient } from '../client';
import { logger } from '../../../utils/logger';
import { ApiErrorHandler } from '../error.handler';
import { BaseEndpoint } from './base.endpoint';

class CalenderEndpoints extends BaseEndpoint {
  private static instance: CalenderEndpoints;

  static getInstance(): CalenderEndpoints {
    if (!CalenderEndpoints.instance) {
      CalenderEndpoints.instance = new CalenderEndpoints();
    }
    return CalenderEndpoints.instance;
  }

  async getGoogleAuthUrl(organizationId: string, resourceId: number): Promise<any> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<{ url: string }>(
        `${this.basePath}/client/${organizationId}/auth/google/url/${resourceId}`,
        {
          headers,
        }
      );

      logger.info('Google Auth URL fetched successfully');
      return response;
    } catch (error) {
      logger.error('Failed to fetch Google Auth URL:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  // next version
  // async getMicrosoftAuthUrl(organizationId: string): Promise<any> {
  //   try {
  //     const headers = await this.getAuthHeaders();
  //     const response = await httpClient.get<{ url: string }>(
  //       `${this.basePath}/client/${organizationId}/auth/microsoft/url`,
  //       {
  //         headers,
  //       }
  //     );

  //     logger.info('Microsoft Auth URL fetched successfully');
  //     return response;
  //   } catch (error) {
  //     logger.error('Failed to fetch Microsoft Auth URL:', error);
  //     return ApiErrorHandler.handle(error);
  //   }
  // }

  async getResourceCalendarProviders(organizationId: string, resourceId: number): Promise<any> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<{ url: string }>(
        `${this.basePath}/organisations/${organizationId}/calendar/provider/${resourceId}`,
        {
          headers,
        }
      );

      logger.info('Resource Calendar Providers fetched successfully');
      return response?.data;
    } catch (error) {
      logger.error('Failed to fetch Resource Calendar Providers:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async unlinkCalendar(
    organizationId: string,
    resourceId: number,
    providerName: string
  ): Promise<any> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.delete(
        `${this.basePath}/organisations/${organizationId}/calendar/unlink/${resourceId}`,
        {
          headers,
          data: { providerName },
        }
      );

      logger.info(`Successfully unlinked ${providerName} calendar`);
      return response;
    } catch (error) {
      logger.error(`Failed to unlink ${providerName} calendar:`, error);
      return ApiErrorHandler.handle(error);
    }
  }
}

export const calenderEndpoints = CalenderEndpoints.getInstance();
